<template>
    <form class="login login--password-email" v-bind:action="apiUrl + '/password/email'" v-on:submit.prevent="handleSubmit">
        <h2 class="view__title">{{ __('Reset Password') }}</h2>

        <div class="form__group has-icon" v-bind:class="{ 'has-error' : errors.email }">
            <label class="form__label" for="email">{{ __('Your Email') }}</label>
            <span class="jam jam-newsletter is-large"></span>
            <input class="form__control is-large" id="email" type="email" autocomplete="off" placeholder="example@gmail.com"
                   v-model="email"
            />
            <span class="form__focus"></span>
        </div>
        <small class="form__error" v-if="errors.email">{{ errors.email[0] }}</small>

        <button class="btn is-primary" type="submit">{{ __('Send Password Reset Link') }}</button>
    </form>
</template>

<script>
    import { eventBus } from '../eventBus.js';

    export default {
        data: function () {
            return {
                email: '',
                errors: {}
            }
        },
        methods: {
            handleSubmit: function (e) {
                eventBus.$emit('show-loader');

                const form = e.target;
                const action = form.getAttribute('action');

                this.$http.post(action, {
                    email: this.email
                }).then(function (response) {
                    eventBus.$emit('show-alert', 'success', this.__('We have e-mailed your password reset link!'));

                    this.$router.push({
                        name: 'startdesks.view',
                        params: { startdesk: this.activeStartdesk.slug, u: this.activeStartdesk.is_user_startdesk }
                    });

                    eventBus.$emit('hide-loader');
                }, function (response) {
                    if (response.status == 422 && response.body.errors) {
                        this.errors = response.body.errors;
                    }

                    eventBus.$emit('hide-loader');
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/PasswordEmail.vue